import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";


import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { getEntity, getEntityDetails, getTask, getTaskById, updateTaskStatus } from "../../http/fundLync/entityAndAddress.helper";
import { decryptedValue, isPermission } from "common/utility";
import TableContainerV1 from "components/Common/TableContainerV1";
import { isEmpty } from "lodash";
import { getDealInfo } from "http/fundLync/deal.helper";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import ToastDialog from "components/Common/ToastDialog";

const TableActionsComponent = (props, entityType) => {
  const navigate = useNavigate();
  const user = decryptedValue(localStorage.getItem("user"));
  const navigateToEditRoles = (id) => {
    const encryptedId = btoa(id.toString());
      navigate(
        `/edit-task/${encodeURIComponent(
          encryptedId
        )}`
      );
  };

  const navigateToDetails = (rowData) => {
    const encryptedId = btoa(rowData.id.toString());
    let url;
      url = `/task-details/${encodeURIComponent(encryptedId)}`;
      navigate(url);
  };
  


  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
            onClick={() => {
                navigateToEditRoles(props.id);
            }}
            >
            <i
                className="mdi mdi-pencil font-size-16 text-success me-1"
                id="edittooltip"
            ></i>
            Edit
            <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
            </UncontrolledTooltip>
            </DropdownItem>
            
            <DropdownItem
                onClick={() => {
                navigateToDetails(props);
                }}
            >
                <i
                className="mdi mdi-eye font-size-16 text-success me-1"
                id="viewTooltip"
                ></i>
                View
                <UncontrolledTooltip placement="top" target="viewTooltip">
                  View
                </UncontrolledTooltip>
            </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const TasksList = (props) => {
  document.title = "List Task | Fundlync";

  const navigate = useNavigate();
  const [taskList, setTaskList] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [isNewEntityPermission, setIsNewEntityPermission] = useState(false);
  const userObj = decryptedValue(localStorage.getItem("user")) || {};
  const { entityType } = userObj || "";
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  });
  const [isStatusModal, setIsStatusModal] = useState(false);
  const [entityStatusBucketList, setEntityStatusBucketList] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });

  const urlParams = new URLSearchParams(window.location.search);
  const filterType = urlParams.get("filter");
  // let decodeFilterType = atob(urlParams.get("filter"));
  const statusColors = {
    "Open": "#3a99db", // blue
    "Completed": "#34c38f", // green
    "In Progress": "#ffc107", // yellow
    "Cancelled": "#f46a6a", // red
  };

  const priorityStyles = {
    "High": { backgroundColor: "#f8d7da", color: "#721c24" }, // light red background, dark red text
    "Medium": { backgroundColor: "#fff3cd", color: "#856404" }, // light yellow background, dark yellow text
    "Low": { backgroundColor: "#d1ecf1", color: "#0c5460" }, // light blue background, dark blue text
    "default": { backgroundColor: "#f0f0f0", color: "#6c757d" } // light grey background, dark grey text
  };

  let handleChange;
  let handleChangeDeal;
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        Cell: (cellProps) => {
          handleChange = () => {
            navigateToEditEntity(cellProps.value)
          }
          handleChangeDeal = () => {
            navigateToDeal(cellProps.value)
          }
          return cellProps.value || '';
        }
      },
      {
        Header: "Entity Name",
        accessor: "entityId",
        filterable: true,
        Cell: (cellProps) => {
          let rowData = cellProps?.row?.original?.entity
          return (
            <div onClick={handleChange}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ cursor: 'pointer', color: '#21aa47' ,width:'120px'}}
              title = {rowData?.entityName || ''}
            >
              {truncateText(rowData?.entityName,20) || ''}
            </div>
          );
        }
      },
      {
        Header: "Deal Name",
        accessor: "dealId",
        filterable: true,
        Cell: (cellProps) => {
          let rowData = cellProps?.row?.original?.deal
          return (
            <div onClick={handleChangeDeal}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ cursor: 'pointer', color: '#21aa47', width: '130px' }}
            title={rowData?.dealName || ''}
          >
            {truncateText(rowData?.dealName, 15) || ''}
          </div>
          );
        }
      },
      {
        Header: "Task Name",
        accessor: "taskName",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Due Date & Time",
        accessor: "dueDate", 
        filterable: true,
        Cell: (cellProps) => {
          const row = cellProps.row.original;
          const dueDate = row.dueDate || "";
          const dueTime = row.dueTime || "";
          return `${dueDate} ${dueTime}`;
        },
      },
      {
        Header: "Reminder",
        accessor: "taskReminder",
        filterable: true,
        Cell: (cellProps) => {
          const reminderValue = cellProps.value;
          if (reminderValue === "0m") {
            return "No reminder";
          }
          return `${reminderValue} Before The Due Time` || "";
        },
      },
      {
        Header: "Task Priority",
        accessor: "taskPriority",
        filterable: true,
        Cell: (cellProps) => {
          const priority = cellProps.value || "";
          const style = priorityStyles[priority] || "";
          return (
            <div
            style={{
              backgroundColor: style.backgroundColor,
              color: style.color,
              padding: "5px 10px",
              borderRadius: "5px",
              width: "100px", 
              height: "30px", 
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              textAlign: "center",
            }}
            >
              {priority || ""}
            </div>
          );
        },
      },
      {
        Header: 'Assign User',
        FullName: "",
        accessor: 'assignedTo',
        filterable: true,
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          let name = ""
            if (rowData.assignedToUser?.firstName) {
              name += capitalizeFirstLetter(rowData.assignedToUser?.firstName) + " "
            }
            if (rowData.assignedToUser?.lastName) {
              name += capitalizeFirstLetter(rowData.assignedToUser?.lastName) + " "
            }
          return name
        }
      },
      {
        Header: "Status",
        accessor: "taskStatus",
        filterable: true,
        Cell: (cellProps) => {
          let rowData = cellProps?.row?.original;
          const status = cellProps.value || "";
          const color = statusColors[status] || "#6c757d";
          return (
            <span onClick={()=>{handleStatusChange(rowData)}}
              // onMouseEnter={handleMouseEnter}
              // onMouseLeave={handleMouseLeave}
              style={{ cursor: 'pointer', color: color, fontWeight: 'bold' }}
            >
              {rowData?.taskStatus || ''}
            </span>
          );
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(rowData, entityType);
        },
      },
    ],
    []
  );
  const capitalizeFirstLetter = (inputString) => {
    if (typeof inputString !== 'string' || inputString.length === 0) {
      return inputString;
    }
    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
    

    return `${day}-${month}-${year}`;
  }

  const convertTo12HourFormat = (time) => {
    let [hours, minutes] = time.split(':');
    hours = parseInt(hours, 10);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert to 12-hour format
    return `${hours}:${minutes} ${ampm}`;
 };

  const validation = useFormik({
  initialValues: {
    id: "",
    taskStatus: "",
  },
  validationSchema: Yup.object({
    taskStatus: Yup.string().required("Please select Task Status"),
  }),
  onSubmit: (values) => {
    const data = {
      id: values.id,
      taskStatus: values.taskStatus,
    }
    updateTaskStatus(data).then((response)=>{
      if(response && response.status){
        setToastInfo({
          message: response.message,
          showToast: true,
          role: "success",
        })
      handlePageChange(pagination.pageIndex || 1, pageSize, searchValue, columnId, sortingOrderStatus);
      }else{
        setToastInfo({
          message: response.message || 'Something went wrong!',
          showToast: true,
          role: "error",
        })
      }
      validation.resetForm()
      setIsStatusModal(false)
    }).catch((error)=>{
      setIsStatusModal(false)
      setToastInfo({
        message: 'Something went wrong!',
        showToast: true,
        role: "error",
      })
    })
  },
  });

  const handleStatusChange = (data) => {
  validation.setFieldValue('id', data.id)
  validation.setFieldValue('taskStatus', data?.taskStatus)
  getDropDownList({ dropdownName: "Task_Status" })
    .then((response) => {
      if (response.status) {
        const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Task_Status")?.dropdownValues || []
        const modifiedDropdownValues = dropdownValues.map(dv => ({
          label: dv.displayName,
          value: dv.dropdownValue
        }));
        setEntityStatusBucketList(modifiedDropdownValues)
        setIsStatusModal(true)
      }
    }).catch((error) => {
      console.log(error);
    })
  };
  const getTasks = (data) => {
    getTask(data)
      .then((responseFromAPI) => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          const FormatedTasks = responseFromAPI.data.data.map(task => {
            return {
              ...task,
              dueDate: formatDate(task.dueDate.split(" ")[0]),
              dueTime: convertTo12HourFormat(task.dueTime),
            };
          });

           setTaskList(FormatedTasks);
          const { totalItems, totalPages, currentPage } = responseFromAPI.data;
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          });
        } else {
          setTaskList([]);
          setPagination({
            pageIndex: 0,
            pageCount: 0,
            totalRecords: 0,
          });
        }
      })
      .catch((error) => {});
  };

  const handlePageChange = (
    page,
    pageSize,
    searchKey=searchValue,
    columnName = columnId,
    sortingOrder = sortingOrderStatus
  ) => {
    setPageSize(pageSize);
    if (filterType) {
      getTasks({
        page,
        limit: pageSize,
        searchKey,
        columnName,
        sortingOrder,
        filterType,
        user: userObj
      });
    } 
    else {
      getTasks({
        page,
        limit: pageSize,
        searchKey,
        columnName,
        sortingOrder,
        user: userObj
      });
    }
  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    if (filterType) {
      if (value) {
        // setSearchValue(value);
        handlePageChange(1, pageSize, value);
      } else {
        // setSearchValue(decodeFilterType);
        handlePageChange(1, pageSize, filterType);
      }
    } else {
      setSearchValue(value);
      handlePageChange(1, pageSize, value);
    }
  };
  const handleClearSearch = () => {
    if (filterType) {
      // setSearchValue(decodeFilterType);
      handlePageChange(1, pageSize, filterType);
    } else {
      setSearchValue("");
      handlePageChange(1, pageSize, "");
    }
  };

  const navigateToEditEntity = async (Id) => {
    try {
      const taskResponse = await getTaskById({ Id });
      const entityId = taskResponse.entityId;
      try {
        const entityDetailsResponse = await getEntityDetails({ entityId });
        const entityType = entityDetailsResponse.data.entity_type;
        const encryptedId = btoa(entityId.toString());
        if (entityType === 'Customer') {
          navigate(`/${userObj.roleName}/entity-Dashboard?id=${encodeURIComponent(encryptedId)}`);
        } else {
          navigate(`/${userObj.roleName}/financierDetails?id=${encodeURIComponent(encryptedId)}`);
        }
      } catch (entityError) {
        console.error('Error fetching entity details:', entityError);
      }
    } catch (dealError) {
      console.log('Error fetching entity details:', dealError)
    }
  };

  const navigateToDeal = async (Id) => {
    try {
      const dealInfoResponse = await getTaskById({ Id });
      const entityId = dealInfoResponse.dealId;
      try {
        const encryptedId = btoa(entityId.toString());
        navigate(`/${userObj.roleName}/viewDeal?id=${encodeURIComponent(encryptedId)}`);
      } catch (entityError) {
        console.error('Error fetching entity details:', entityError);
      }
    } catch (dealError) {
      console.log('Error fetching entity details:', dealError)
    }
  };

  const handleMouseEnter = (event) => {
    event.target.style.color = "#34c38f";
    event.target.style.textDecoration = 'underline';
  };
  const handleMouseLeave = (event) => {
    event.target.style.color = "#21aa47";
    event.target.style.textDecoration = 'none';
  };

  const truncateText = (text, charLimit) => {
    if (text && text.length > charLimit) {
        const truncated = text.substring(0, charLimit) + '...';
        return truncated;
    }
    return text;
};

  useEffect(() => {
    if (filterType) {
      getTasks({ filterType, user: userObj });
    } else {
      getTasks({user: userObj});
    }
    checkPermissions();
  }, []);

  const checkPermissions = async () => {
    const isNewEntitypermission = await isPermission(
      "apiConfiguration",
      "create_permission"
    );
    setIsNewEntityPermission(isNewEntitypermission);
  };

  const handleCustomerClicks = () => {
    navigate(`/${userObj.roleName}/add-task`);
  };

  const buttonSection = (
    <div className="text-sm-end">
        <Button
          type="button"
          style={{ backgroundColor: '#21aa47', borderColor: '#21aa47' }}
          className="btn-rounded mb-2 me-2"
          onClick={handleCustomerClicks}
        >
          <i className="mdi mdi-plus me-1" />
          {"New Task"}
        </Button>
    </div>
  );

  return (
    <React.Fragment>
    <div className="page-content">
        <Container fluid> 
        <Breadcrumbs title="Task List" />
            <Row className="vertical-scroll">
                <Col xs="12">
                <Card>
                    <CardBody>
                    <TableContainerV1
                        columns={columns}
                        data={taskList}
                        pagination={pagination}
                        handlePageChange={handlePageChange}
                        handleSearchFilter={handleSearchFilter}
                        customSection={buttonSection}
                        sortOptions={sortingOptions}
                        handleSortColumn={handleSortColumn}
                        handleClearSearch={handleClearSearch}
                        className="custom-header-css"
                    />
                    </CardBody>
                </Card>
                </Col>
            </Row>
          <ToastDialog
            message={toastInfo.message || ""}
            showToast={toastInfo.showToast}
            role={toastInfo.role}
            onCloseFn={() => setToastInfo({ showToast: false })}
          ></ToastDialog>

          <Modal
            isOpen={isStatusModal}
            role="dialog"
            autoFocus={true}
            centered
            data-toggle="modal"
            toggle={() => {
              setIsStatusModal(!isStatusModal);
            }}
          >
            <div>
              <ModalHeader
                className="border-bottom-0"
                toggle={() => {
                  setIsStatusModal(!isStatusModal);
                }}
              ></ModalHeader>
            </div>
            <div className="modal-body">
              <div className="text-center mb-4">
                <div className="row justify-content-center">
                  <div className="col-xl-10">
                    <h4 className="text-success">Select Task Status</h4>
                    <Form
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <Col xl={12} >
                        <Input
                          name="taskStatus"
                          type="select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.taskStatus}
                          invalid={validation.touched.taskStatus && !!validation.errors.taskStatus}
                        >
                          <option value="" selected disabled>Select Task Status</option>
                          {entityStatusBucketList?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}

                        </Input>
                        {validation.touched.taskStatus && validation.errors.taskStatus ? (
                          <FormFeedback type="invalid">
                            {validation.errors.taskStatus}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Row>
                        <Col sm="12" >
                          <div className="d-flex gap-3 justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-success save-customer mt-2"
                            >
                              Submit
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </Container>
    </div>
</React.Fragment>
  );
};

export default TasksList;
